<template>
<ul class="micad_unorderedList">
  <li v-for="item in items" :key="item" class="micad_unorderedList_item">{{item}}</li>
</ul>
</template>

<script>
export default {
  name: 'Unordered-list',
  data() {
    return {
        items: ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5", "Item 6"],
        }
    },
};
</script>
